import { useState,type FormEvent } from 'react';
import { Button } from './Button';

export interface OrganisationClaim {
  id:string;legal_name:string;registration_type:'RC'|'BN'|'IT'|'ASSISTED';registration_number:string|null;
  representative_role:'OWNER'|'DIRECTOR'|'AUTHORISED_REPRESENTATIVE';
  state:'PENDING'|'NEEDS_INFORMATION'|'VERIFIED'|'JOIN_REQUIRED'|'REJECTED';
  organisation_id:string|null;public_message:string|null;
}
export interface OrganisationInput {
  legal_name:string;registration_type:OrganisationClaim['registration_type'];registration_number?:string;
  representative_role:OrganisationClaim['representative_role'];
}

/** Identity and authority decisions are made by the server, never this form. */
export function OrganisationSetup({claim,ready,busy,submit,refresh}:{
  claim:OrganisationClaim|null;ready:boolean;busy:boolean;
  submit:(input:OrganisationInput)=>Promise<void>;refresh:()=>Promise<void>;
}) {
  const [name,setName]=useState(claim?.legal_name??'');
  const [type,setType]=useState<OrganisationClaim['registration_type']>(claim?.registration_type??'RC');
  const [number,setNumber]=useState(claim?.registration_number??'');
  const [role,setRole]=useState<OrganisationClaim['representative_role']>(claim?.representative_role??'OWNER');
  const canSubmit=!claim||['NEEDS_INFORMATION','REJECTED'].includes(claim.state);
  function onSubmit(event:FormEvent){event.preventDefault();void submit({legal_name:name,registration_type:type,
    ...(type==='ASSISTED'?{}:{registration_number:number}),representative_role:role});}
  return <section aria-labelledby="organisation-setup-heading">
    <h2 id="organisation-setup-heading">Your organisation</h2>
    <p>One subscription per organisation for this product. If your firm already uses it, ask its administrator for access instead of buying again.</p>
    {!ready&&<p>Verify your email and phone, then sign in with a passkey or authenticator to continue.</p>}
    {claim?.state==='VERIFIED'&&<p role="status">{claim.legal_name} is verified. You can continue to payment below.</p>}
    {claim?.state==='PENDING'&&<p role="status">Your organisation details are awaiting review. No payment is needed yet.</p>}
    {claim?.public_message&&<p role="status">{claim.public_message}</p>}
    {claim?.state==='JOIN_REQUIRED'&&<p>Verification has not granted workspace access. Amoye will help route your request to the authorised administrator without creating another subscription.</p>}
    {canSubmit&&<form onSubmit={onSubmit}>
      <label htmlFor="organisation-name">Legal organisation or firm name</label>
      <input id="organisation-name" autoComplete="organization" minLength={2} maxLength={160} required value={name} onChange={e=>setName(e.target.value)}/>
      <label htmlFor="organisation-registration-type">Registration type</label>
      <select id="organisation-registration-type" value={type} onChange={e=>setType(e.target.value as OrganisationClaim['registration_type'])}>
        <option value="RC">CAC company (RC)</option><option value="BN">CAC business name (BN)</option>
        <option value="IT">CAC incorporated trustees (IT)</option><option value="ASSISTED">I need help verifying my organisation</option>
      </select>
      {type!=='ASSISTED'?<><label htmlFor="organisation-registration-number">CAC registration number</label>
        <input id="organisation-registration-number" maxLength={24} required value={number} onChange={e=>setNumber(e.target.value)}/></>
        :<p>A sole practitioner or organisation without these registration details can request assisted verification. You do not need to invent a registration number.</p>}
      <label htmlFor="organisation-role">Your authority to set up this organisation</label>
      <select id="organisation-role" value={role} onChange={e=>setRole(e.target.value as OrganisationClaim['representative_role'])}>
        <option value="OWNER">Owner</option><option value="DIRECTOR">Director</option><option value="AUTHORISED_REPRESENTATIVE">Authorised representative</option>
      </select>
      <p>Amoye checks both the organisation record and your authority to act for it. A matching email domain or payment alone is not proof of ownership.</p>
      <Button type="submit" disabled={busy||!ready||name.trim().length<2||(type!=='ASSISTED'&&!number.trim())}>Submit organisation for verification</Button>
    </form>}
    {claim&&<Button tone="secondary" disabled={busy} onClick={()=>void refresh()}>Refresh organisation status</Button>}
  </section>;
}
